var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('orderList',{attrs:{"orderInforList":_vm.orderInforList,"myWaitForReceivingCount":_vm.myWaitForReceivingCount,"totalNum":_vm.totalNum},on:{"onLoad":_vm.onLoad}})}
var staticRenderFns = []

export { render, staticRenderFns }